import { createAsyncAction } from 'typesafe-actions';
import { IdType } from '@rootCommon/types/common';
import { OrganizationSecuritySetting, OrganizationSecuritySettingDto } from '@rootCommon/types/orgSecuritySetting';

export const fetchSecuritySetting = createAsyncAction(
  'FETCH_SECURITY_SETTING_REQUEST',
  'FETCH_SECURITY_SETTING_SUCCESS',
  'FETCH_SECURITY_SETTING_FAILURE',
)<IdType, OrganizationSecuritySetting, Error>();

export const updateSecuritySetting = createAsyncAction(
  'UPDATE_SECURITY_SETTING_REQUEST',
  'UPDATE_SECURITY_SETTING_SUCCESS',
  'UPDATE_SECURITY_SETTING_FAILURE',
)<{ id: IdType; data: OrganizationSecuritySettingDto }, OrganizationSecuritySetting, Error>();
